import React, { forwardRef } from 'react';
import { getButtonClassName } from '../../utils/buttonStyles.js';

/**
 * Button with variants (primary, secondary, danger, ghost) and sizes (sm, md, lg).
 * `isLoading` disables it and marks it busy, so a pending action cannot be sent twice.
 * Any other prop is forwarded to the native <button>.
 */
const Button = forwardRef(({
  variant = 'primary',
  size = 'md',
  isLoading = false,
  disabled = false,
  type = 'button',
  className = '',
  children,
  ...props
}, ref) => (
  <button
    ref={ref}
    type={type}
    disabled={disabled || isLoading}
    aria-busy={isLoading || undefined}
    className={getButtonClassName({ variant, size, className })}
    {...props}
  >
    {isLoading && (
      <span
        aria-hidden="true"
        className="h-4 w-4 animate-spin rounded-full border-2 border-current border-t-transparent"
      />
    )}
    {children}
  </button>
));

Button.displayName = 'Button';

export default Button;
